module.exports = __webpack_public_path__ + "static/img/h4.9ca0e17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/multidaytours/tour3/h4.jpg
// module id = BI0R
// module chunks = 0